import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { WhatsappApi } from "./api";
import { WatiSettings } from "./types";


const QUERY_KEYS = {
    all: ['settings'] as const,
};
  

export const useGetSettings = () => {
    return useQuery({
        queryKey: QUERY_KEYS.all,
        queryFn: () => WhatsappApi.getWatiSettings(),
    });
};

export const useAddSettings = () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: (data: WatiSettings) => WhatsappApi.addWatiSettings(data),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: QUERY_KEYS.all});
      },
    });
};